import { Module } from "vuex";
import { clone, mergeObjects } from '../../../utils/general';
import { RootState } from '../../types';
import { SubscriptionPreferenceState } from './types';
import { subscriptionPreferenceActions } from './actions';

export const initialSubscriptioPreferencenState = (): SubscriptionPreferenceState => ({
  subscriptionPreference: {
    oid: null,
    enabled: true,
  },
});

export const subscriptionPreferenceModule: Module<SubscriptionPreferenceState, RootState> = {
  namespaced: true,
  state: initialSubscriptioPreferencenState(),
  actions: subscriptionPreferenceActions,
  mutations: {
    SET_SUBSCRIPTION_PREFERENCE(state, data: object) {
      state.subscriptionPreference = clone(data);
    }
  },
  getters: {
    isSubscriptionPreferenceEnabled(state) {
      return state.subscriptionPreference?.enabled;
    },
  }
};

export default subscriptionPreferenceModule;